import { render } from "./PageNewsletter.vue?vue&type=template&id=dbe37360"
import script from "./PageNewsletter.vue?vue&type=script&lang=js"
export * from "./PageNewsletter.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__